/// <reference path="../../../ts/libs.ts" />

import { Set } from '../../../ts/models/Set';
import { SiteUsers } from '../../../ts/resources/SiteUsers';
import { SiteRoles } from '../../../ts/ServerApi/types/ISiteRole';
import { IUserActionResult, UserActionResultCode } from '../../../ts/ServerApi/types/IUserActionResult';
import { ServerService } from '../../../ts/services/ServerService';
import { AuthenticationProviderType, IAuthenticationProvider } from '../../../ts/services/SiteAuthenticationSettingsService';
import { UserActionNotification, UserActionNotificationParams } from '../../../ts/services/UserActionNotification';
import { ServiceLocator } from '../../ServiceLocator';
import { AddLocalUsersDialogProps, INewUserFlowModel } from '../AddLocalUsersDialog';

export class CreateLocalSiteUserHelperService {
  private server: ServerService = ServiceLocator.get<ServerService>('ServerService');
  private siteUsers: SiteUsers = ServiceLocator.get<SiteUsers>('SiteUsers');
  private userActionNotification: UserActionNotification = ServiceLocator.get<UserActionNotification>('UserActionNotification');

  public createLocalSiteUser(username: string, model: INewUserFlowModel, siteRole: string,
                             authenticationProvider: IAuthenticationProvider, props: AddLocalUsersDialogProps,
                             setErrorTextCallback: (errorMsg: string) => void,
                             setBusyState: (busy: boolean) => void) {
    // get the currently selected site role off the scope
    let siteRoleToGiveNewUser = siteRole;
    // set a flag to true if the currently selected role is Server Admin
    const makeServerAdmin = (siteRoleToGiveNewUser === SiteRoles.ServerAdministrator) || null;
    // if setting to server admin, we don't pass the role to the backend.
    // because the server admin flag & the site role string are mutually exclusive.
    if (makeServerAdmin) {
      siteRoleToGiveNewUser = null;
    }
    let action: ng.IPromise<IUserActionResult>;
    const isLocalAuth = authenticationProvider.type === AuthenticationProviderType.default && !this.server.isAuthenticationSaml();
    if (isLocalAuth) {
      action = this.siteUsers.createLocalUser(
        username,
        model.displayName,
        model.email,
        model.password,
        makeServerAdmin,
        siteRoleToGiveNewUser
      );
    } else {
      action = this.siteUsers.createLocalUserWithSamlOrSiteSamlAuth(
        username,
        model.displayName,
        model.email,
        authenticationProvider.id,
        makeServerAdmin,
        siteRoleToGiveNewUser
      );
    }
    action.then((result: any) => {
      this.showNotificationForCreateUser(result, siteRoleToGiveNewUser, setErrorTextCallback);
      if (!!result.errors && result.errors.length > 0) {
        setBusyState(false);
      } else {
        props.emitUserAddedEvent();
        props.close(result);
      }
    });
  }

  public showNotificationForCreateUser(result: IUserActionResult, siteRole: string, setErrorTextCallback: (errorMsg: string) => void) {
    const params: UserActionNotificationParams = {
      users: Set.fromIdItemArray(result.users),
      results: result.results,
      errors: result.errors,
      successCode: UserActionResultCode.siteUserCreated,
      siteRole: siteRole,
      showErrorMsgFunc: (errorMsg: string) => {
        setErrorTextCallback(errorMsg);
      }
    };
    this.userActionNotification.notify(params);
  }
}
